/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

//const url = 'course-classes/{course}/timetables'

export default {
  getList({ commit }, { course_id, param }) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `course-classes/${course_id}/timetables?${new URLSearchParams(
            param,
          )}`,
        )
        .then((response) => {
          const data = response.data.data;
          if (data && data.pagination) {
            commit("SET_LIST_WITH_PAGINATION", data);
          } else {
            commit("SET_LIST", data);
          }
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDetail({ commit }, { course_id, timetable_id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `course-classes/${course_id}/timetables/${timetable_id}?${new URLSearchParams(
            query,
          )}`,
        )
        .then((response) => {
          commit("SET_DETAIL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
